import { styled } from "@mui/system";
import { Box, Button } from "@mui/material";

export const HeaderContainer = styled(Box)({
  display: "flex",
  width: '100%',
  padding: '8px 0',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '2px',
});

export const BackButtonContainer = styled(Button)({
  display: "flex",
  flexDirection: 'row',
  padding: '9px',
  alignItems: 'center',
  gap: '5px',
  alignSelf: 'stretch',
  justifySelf: 'center',
  backgroundColor: 'transparent',
  width: '112px',

  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:focus': {
    outline: 'none',
    backgroundColor: 'transparent',
  },
  '&:active': {
    backgroundColor: 'transparent',
    outline: 'none',
  },
});

export const TitleContainer = styled(Box)({
  justifySelf: 'center',
  alignSelf: 'center',
  paddingLeft: '18px'
});

export const CombinedContainer = styled(Box)({
  width: "390px",
  minHeight: "560px",
  flexShrink: '0',
  borderRadius: "32px",
  background: 'var(--BG-Primary---Dark-Base, #000)',
});


